import React from 'react'
import { SubTitle } from '../../../common/form-components/label/Label'
import FulesPriceTable from '../FuelsPriceTable'

const NotifiedToPricesAllGasStation = ({ prices, removeItemCenterPrice }) => {
  return (
    <>
      <SubTitle id="notified.to.prices" />
      <FulesPriceTable
        prices={prices}
        showChangeDate
        withfuelStation
        handleDelete={removeItemCenterPrice}
      />
    </>
  )
}

export default NotifiedToPricesAllGasStation
